<i class="fas fa-{{iconSize}} fa-{{iconType}} foundation-status text-{{iconColor}}" [ngbTooltip]="tooltipText"></i>
